/**
 * User Entity Schema
 *
 * Core representation of user entities used across the platform.
 */

import { z } from 'zod'
import { SchoolSummarySchema } from './school'

/**
 * User Summary Schema
 * Minimal user info for references and list views
 */
export const UserSummarySchema = z.object({
  id: z.string().describe('User public ID'),
  firstName: z.string().describe('User first name'),
  lastName: z.string().describe('User last name'),
  email: z.string().email().describe('User email address')
})

export type UserSummary = z.infer<typeof UserSummarySchema>

/**
 * User with Schools Schema
 * Full user info including associated schools
 */
export const UserWithSchoolsSchema = z.object({
  id: z.string().describe('User unique identifier (CUID)'),
  firstName: z.string().describe('User first name'),
  lastName: z.string().describe('User last name'),
  email: z.string().email().describe('User email address'),
  photoUrlThumbnail: z.string().nullable().optional().describe('Thumbnail photo URL'),
  photoUrlLarge: z.string().nullable().optional().describe('Large photo URL'),
  schools: z.array(SchoolSummarySchema).describe('Schools associated with the user')
})

export type UserWithSchools = z.infer<typeof UserWithSchoolsSchema>
